export const uiState = {
    currentTheme: null,
    lib: {
        version: ''
    },
    project: {
        id: null
    },
    btn: {
        isTopAligned: false,
        zIndex: undefined
    },
    textChat: {
        available: false,
        expanded: false,
        inlined: false,
        options: null,
        loaderTimeoutMs: 1800000,
        defaults: {
            minChatWidth: 250,
            appearAnimationMs: 200,
            chatMargin: 25,
            textareaFontSize: 15,
            textareaLineHeight: 1.6,
            defaultSvgIconSize: 24,
        }
    }
};